import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueSimpleAlert from 'vue-simple-alert'

Vue.config.productionTip = false
Vue.config.devtools = true
Vue.use(VueSimpleAlert, {
  customClass: {
    container: 'led-container',
    popup: 'led-popup',
    header: 'led-header',
    title: 'led-title',
    closeButton: 'led-closeButton',
    icon: 'led-icon',
    image: 'led-image',
    content: 'led-content',
    htmlContainer: 'led-htmlContainer',
    input: 'led-input',
    inputLabel: 'led-inputLabel',
    validationMessage: 'led-validationMessage',
    actions: 'led-actions',
    confirmButton: 'led-confirmButton',
    denyButton: 'led-denyButton',
    cancelButton: 'led-cancelButton',
    loader: 'led-loader',
    footer: 'led-footer',
    timerProgressBar: 'led-timerProgressBar',
  },
  confirmButtonText: 'OK',
  cancelButtonText: 'Cancel',
  reverseButtons: true,
  showCloseButton: true,
  allowOutsideClick: false,
})

new Vue({
  store,
  render: (h) => h(App),
}).$mount('#case-study-map-app')
